import { legacyRouteQuery } from '@/features/stockchart/models/legacyQuerySelection';
import { legacyFinderToMarketQuery } from '@/features/stockchart/explorer/legacyFinderMapper';

export function usageFilters(finder) {
  try { return legacyFinderToMarketQuery(typeof finder === 'object' && finder ? finder : {}).filters; }
  catch (_) { return {}; }
}
export function legacyUsageState(vm) {
  const s = vm.$store.state, ticker = s.selected_ticker || {};
  const query = vm._legacyQuery ? vm._legacyQuery.current() : legacyRouteQuery(vm.$route);
  return {
    source: query.source,
    query_tool: query.tool,
    ticker: String(ticker.ticker || '').slice(0, 64),
    direction: String(ticker.direccio == null ? '' : ticker.direccio),
    entry_type: String(ticker.tipus_entrada == null ? '' : ticker.tipus_entrada),
    view: vm.isMobile ? s.toggleChartStocks : s.show_stockchart_list ? 'chart' : 'table',
    theme: s.dark_theme ? 'dark' : 'light',
    device: vm.isMobile ? 'mobile' : 'desktop',
    viewport: [window.innerWidth, window.innerHeight],
    portfolio_id: String(s.portfolio_id_selected || ''),
    filters: usageFilters(s.finder), crypto: Boolean(s.crypto_enable),
    sort: (s.order_by || []).slice(0, 3), result_count: (s.stocks || []).length,
    loading: Boolean(s.is_loading_stocks), fullscreen: Boolean(vm.fullscreenActive),
    navigation_hidden: Boolean(vm.classicChartNavigation && vm.classicChartNavigation.hidden)
  };
}
export function legacyUsagePanels(vm) {
  const s = vm.$store.state;
  const mobile = ['info', 'fundamental', 'description', 'comments', 'error', 'simulator', 'order', 'notas', 'alarms'].find(key => s[`open_${key}`]);
  return {
    left: s.show_stock_finder_filters ? 'filters' : s.tickers_finder ? 'description-search' : vm.isMobile && s.open_favorites ? 'favorites' : vm.isMobile && s.open_searches ? 'saved-searches' : '',
    right: vm.isMobile ? mobile || '' : s.active_right_component || '',
    mobile_tools: vm.mobileToolsOpen ? 'tools' : ''
  };
}
export const preferenceFields = list => (list || []).map(item => item.field).filter(field => typeof field === 'string' && /^[a-z0-9_]{1,64}$/i.test(field)).slice(0, 80);
